import notify from "devextreme/ui/notify";
import { Injectable } from "@angular/core";
import { iBisEntityService } from "@dohu/ibis-entity";
import { iBisLanguageService, iBisServerConfig } from "@dohu/ibis-common";
import { iBisAuthService, iBisSecureEditService } from "@dohu/ibis-auth";
import { AuthDetailsService } from '../../../../common/auth-details/auth-details.service';
@Injectable()
export class CancelAppointmentService extends iBisSecureEditService {

    constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService, private ad: AuthDetailsService) {
        super(auth, entity, config, lg);
        this.title = this.L('CONFIRM_DELETE')
        this.validation = 'cancelAppointmentValidation';
    }
    protected load(): void {
    }
    createDefault() {
        return {};
    }
    getById(id: string, serverUrl?: string): Promise<any> {
        throw new Error("Method not implemented.");
    }
    onRemove(id: string): Promise<void> {
        throw new Error("Method not implemented.");
    }
    onSaveEv(serverUrl?: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.entity.update('Appointment', this.model.ap_id, { statusId: 10 }).then(data => {
                resolve(data);
                this.hidePopup();
            }, err => this.lg.showError(err));
        });
    }

    reset(): void {
        this.model = {};
    }

    popupInit(ev: any) {
        super.popupInit(ev);
        ev.component.beginUpdate();
        const tbBtns = [
            {
                location: 'after',
                options: {
                    text: this.L('YES'),
                    type: 'default',
                    onClick: (e: any) => {
                        if (!e.validationGroup.validate().isValid) { return; }
                        this.onSaveEv()
                    }
                },
                toolbar: 'bottom',
                widget: 'dxButton'
            }, {
                location: 'after',
                options: {
                    text: this.L('NO'),
                    type: 'default',
                    onClick: (e: any) => {
                        this.hidePopup()
                    }
                },
                toolbar: 'bottom',
                widget: 'dxButton'
            },];
        ev.component.option('toolbarItems', tbBtns);
        ev.component.endUpdate();
    }
}